import React from 'react';

export default () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.21636 22.0552L4.89942 22.0552C5.31044 22.0552 5.69358 21.8473 5.91758 21.5026L10.8222 13.957L9.0596 11.2453C8.34129 10.1402 6.72341 10.1402 6.0051 11.2453L0.19819 20.179C-0.326914 20.9869 0.252843 22.0552 1.21636 22.0552Z" fill="#CB2233" />
    <path d="M9.56499 22.0552L13.248 22.0552C13.6591 22.0552 14.0422 21.8473 14.2662 21.5026L19.1709 13.957L17.4082 11.2453C16.6899 10.1402 15.072 10.1402 14.3537 11.2453L8.54682 20.179C8.02172 20.9869 8.60148 22.0552 9.56499 22.0552Z" fill="#CB2233" />
    <path d="M23.544 22.0994H19.5379C18.5207 22.0994 17.5704 21.5923 17.0041 20.7474C16.8769 20.5577 16.8748 20.3106 16.9987 20.1187L19.6509 16.0103C19.8298 15.7332 20.2349 15.7323 20.415 16.0087L23.9255 21.3954C24.1229 21.6983 23.9056 22.0994 23.544 22.0994Z" fill="url(#paint0_linear)" />
    <circle cx="7.46175" cy="4.28987" r="3.28987" fill="#CB2233" />
    <circle cx="15.557" cy="4.28987" r="3.28987" fill="#CB2233" />
    <defs>
      <linearGradient id="paint0_linear" x1="20.746" y1="19.575" x2="18.8048" y2="17.7249" gradientUnits="userSpaceOnUse">
        <stop stopColor="#CB2233" />
        <stop offset="1" stopColor="#910000" />
      </linearGradient>
    </defs>
  </svg>

);
